export function getPassThroughParams<T>(queryParams: URLSearchParams, passThroughParams: (keyof T)[]) {
  const result: Partial<T> = {};
  const normalizedParams = new Map(passThroughParams.map((param) => [param.toString().toLowerCase(), param]));
  queryParams.forEach((value, key) => {
    const normalizedKey = key.toLowerCase();
    if (normalizedParams.has(normalizedKey)) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- bleh
      const originalKey = normalizedParams.get(normalizedKey)!;
      result[originalKey] = value as T[keyof T];
    }
  });

  return result;
}
